const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <div className="copy-that">
            ©{year} Baidu&nbsp;
            <a href="http://www.baidu.com/duty/" target="_blank" rel="noreferrer">
                使用百度前必读
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://cloud.baidu.com/qualification/isp.html" target="_blank" rel="noreferrer">
                增值电信业务经营许可证：B1.B2-20100266
            </a>
            京ICP证030173号&nbsp;&nbsp;&nbsp;&nbsp;
            <a target="blank" href="https://cloud.baidu.com/doc/Agreements/s/Kjwvy245m/">
                隐私政策
            </a>
        </div>
    );
};
export default Footer;
